module.exports = __webpack_public_path__ + "img/building11.e45d322b.jpg";